import { fetchBaseQuery, createApi } from "@reduxjs/toolkit/query/react";
import { setCredentials } from "./authSlice";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_ENV === "production" ? process.env.REACT_APP_BACKEND_URL_PROD : process.env.REACT_APP_BACKEND_URL_DEV,
  credentials: "include",
  // prepareHeaders: (headers, {getState}) => {
  //     const token = getState().auth.token

  //     if(token){
  //         headers.set("authorization", `Bearer ${token}`)
  //     }

  //     return headers
  // }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 403) {
    console.log("sending refresh token");

    // Send refresh token to get new access token
    const refreshResult = await baseQuery("/auth/refresh", api, extraOptions);

    if (refreshResult?.data) {
      // Store the new token
      api.dispatch(setCredentials({ ...refreshResult.data }));

      // Retry original query with new access token
      result = await baseQuery(args, api, extraOptions);
    } else {
      if (refreshResult?.error?.status === 403) {
        refreshResult.error.data.message = "Your login has expired";
      }

      return refreshResult;
    }
  }

  return result;
};

export const apiSlice = createApi({
  // Base Query for Classic JWT authorization
  baseQuery,
  // Base Query for Refresh/Access Token
  // baseQuery: baseQueryWithReauth,
  tagTypes: ["User", "Game", "Review", "News"],
  endpoints: (builder) => ({}),
});
